// RegisterScreen.jsx
import React, { useContext, useEffect, useState } from "react";
import "./index.scss"; // Make sure your SCSS file is named accordingly
import NavBar from "../../components/Navbarr";
import Footerr from "../../components/Footerr";
import { register } from "../../services/post-register";
import { toast } from "react-toastify";
import { UserContext } from "../../components/context/userContext";
import { useNavigate } from "react-router-dom";

const RegisterScreen = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { isAuthenticated } = useContext(UserContext);

  const navigate = useNavigate();

  const doRegister = (values: any) => {
    const data = {};
    register(values)
      .then((response: any) => {
        if (response?.status === 500) {
          toast.error("Internal server error!");
          return;
        }
        if (!response?.success) {
          toast.error(response?.err);
          return;
        }
        if (response?.success) {
          toast.success(response?.message);
          setUsername("");
          setPassword("");
          setEmail("");
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const handleRegister = (e: any) => {
    e.preventDefault();
    // Implement your register logic here
    doRegister({
      name: username,
      email: email,
      password: password,
      role: 0,
    });
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/acceuil");
    }
  }, [isAuthenticated]);

  return (
    <div>
      <div>
        <NavBar />
      </div>
      <div className="register-container">
        <div className="register-card">
          <h2>Create Account</h2>
          <p className="instruction-text">
            Follow the instructions to make it easier to register and you will
            be able to explore inside.
          </p>
          <form onSubmit={handleRegister}>
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="input-field"
            />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-field"
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-field"
            />
            <button type="submit" className="create-account-button">
              Create Account
            </button>
            <div className="social-login-buttons">
              <button className="google-button" disabled={true}>
                <img src="./../../assets/goo.png" alt="googleImage" />
                <p style={{ marginLeft: 20, height: "40%" }}>Google</p>
              </button>
              <button className="facebook-button" disabled={true}>
                <img src="./../../assets/fbIcon.png" alt="fbImage" />

                <p style={{ marginLeft: 20, height: "40%" }}>Facebook</p>
              </button>
            </div>
          </form>
        </div>
      </div>
      <div>
        <Footerr />
      </div>
    </div>
  );
};

export default RegisterScreen;
